import cookieConfig from './cookieConfig'
import 'cookieconsent/src/cookieconsent.js'
import 'cookieconsent/build/cookieconsent.min.css'

document.addEventListener('DOMContentLoaded', () => {
  window.cookieconsent.initialise(cookieConfig)
})
